<template>
  <div>
      <div class="contents">
          <goods-class-title :src="require('@/assets/images/videobanner.png')" :imgwidth="1083" :margintop="137" :marginbottom="45" />
      </div>
      <!-- <index-banner :src="require('@/assets/images/goodsvideo.jpg')" /> -->
      <video width="100%" autoplay muted loop>
        <source src="/static/video/003.mp4" type="video/mp4">
      </video>
  </div>
</template>

<script>
import IndexBanner from '../IndexBanner.vue'
import GoodsClassTitle from './GoodsClassTitle.vue'
export default {
  components: { GoodsClassTitle,IndexBanner },

}
</script>

    IndexBanner
<style>

</style>


// WEBPACK FOOTER //
// src/components/index/GoodsVideo.vue